import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Manifesto } from "../components/Manifesto";
import { Favourites } from "../components/Favourites";
import { OrderSection } from "../components/OrderSection";
import { Loyalty } from "../components/Loyalty";
import { Story } from "../components/Story";
import { Gallery } from "../components/Gallery";
import { Reviews } from "../components/Reviews";
import { Contact } from "../components/Contact";
import { Social } from "../components/Social";
import { scrollToId } from "../data/site";

export default function Home() {
    const location = useLocation();

    useEffect(() => {
        const target = location.state?.scrollTo;
        if (target) {
            const t = setTimeout(() => scrollToId(target), 120);
            return () => clearTimeout(t);
        }
    }, [location.state]);

    return (
        <main data-testid="home-page">
            <Hero />
            <Marquee />
            <Manifesto />
            <Favourites />
            <OrderSection />
            <Loyalty />
            <Story />
            <Gallery />
            <Reviews />
            <Contact />
            <Social />
        </main>
    );
}
